import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTableClassNames } from './utils/useTableClassNames';
import { TableRoot } from './style';
import { tableDefaultTheme } from './theme';
import { tableRootTestId, TABLE_CLASS_PREFIX } from './constants';
import { TableContext } from './utils/TableContext';
import { useTable } from './utils/useTable';
export var Table = forwardRef(function Table(_ref, ref) {
  var className = _ref.className,
      stickyColumns = _ref.stickyColumns,
      stickyHead = _ref.stickyHead,
      restProps = _objectWithoutProperties(_ref, ["className", "stickyColumns", "stickyHead"]);

  var theme = useComponentTheme(TABLE_CLASS_PREFIX, tableDefaultTheme);
  var classNameComponents = useTableClassNames(TABLE_CLASS_PREFIX, className);

  var _useTable = useTable({
    stickyColumns: stickyColumns,
    stickyHead: stickyHead,
    ref: ref
  }),
      tableContextValue = _useTable.tableContextValue,
      rootReference = _useTable.rootReference,
      onLayoutUpdate = _useTable.onLayoutUpdate;

  return React.createElement(TableContext.Provider, {
    value: tableContextValue
  }, React.createElement(TableRoot, Object.assign({
    "data-testid": tableRootTestId
  }, restProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: rootReference,
    cellPadding: "0",
    cellSpacing: "0",
    onScroll: onLayoutUpdate
  })));
});
Table.defaultProps = {
  horizontalScroll: false,
  stickyHead: false,
  enableFixedLayout: true
};